import { useState, useEffect } from "react";

import type { FeatureFlagHookReturn } from "./useFeatureFlag.types";

export const useFeatureFlag = (): FeatureFlagHookReturn => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const update = () => {
      if (window.MAGALU_CHANNEL) setData(window.MAGALU_CHANNEL);
    };

    update();
    window.addEventListener("magalu-channel-loaded", update);

    return () => {
      window.removeEventListener("magalu-channel-loaded", update);
    };
  }, []);

  return {
    channelConfigs: data?.channel_configs,
    channelName: data?.channel_name,
    isLoaded: !!data,
  };
};
